
<section class="block mx-auto mt-32 max-w-448">
  <SitterAlertBanner v-if="serverError" :error="serverError" />
  <PoppinsCard>
    <h1 class="text-h4 text-m3 pb-12 leading-8">Add your legal address</h1>
    <h3 class="text-grey-text-subdued leading-6 mb-24">
      This is used for Trust and Safety purposes and will not be visible on your profile
    </h3>
    <form id="sitter-address" novalidate @submit.prevent="handleSubmit">
      <AddressAutoComplete
        ref="addressAutoComplete"
        :storedAddress="form"
        :requiredFields="requiredFields"
        @input="handleAddress"
      />
      <PoppinsSpinner v-if="showLoader" class="m-auto" />
      <PoppinsButton
        id="formSubmit"
        :loading="false"
        class="w-full my-8"
        variant="primary"
        value="Continue"
        size="medium"
        type="submit"
      />
    </form>
  </PoppinsCard>
</section>
